var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bg-white rounded-xl"},[_c('div',{ref:"qrCodeCanvas"})])
}
var staticRenderFns = []

export { render, staticRenderFns }